import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const ROLES_EVENT_NAMES = {
  ROLE_PAGE_ACCESS: 'role_page_access_saved',
  ADD_ROLE: 'add_new_role',
};

export const trackRolePageAccess = (role, pageAccess, irpVersion) => {
  const displayPageAccess = pageAccess.join();

  gspx.trackEvent({
    name: ROLES_EVENT_NAMES.ROLE_PAGE_ACCESS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Selected/Checked and saved ${displayPageAccess}`,
      Category: 'Admin',
      'Launched date': new Date(),
      irpVersion,
      Role: role,
    },
  });
};

export const trackAddRole = (role, irpVersion) => {
  gspx.trackEvent({
    name: ROLES_EVENT_NAMES.ADD_ROLE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Add a new role ${role}`,
      Category: 'Admin',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
